{
  "$schema": "https://mux.run/theme.json",
  "name": "Cursor",
  "id": "cursor",
  "light": {
    "palette": {
      "neutral": "#fcfcfc",
      "ink": "#141414",
      "primary": "#6f9ba6",
      "accent": "#6f9ba6",
      "success": "#1f8a65",
      "warning": "#db704b",
      "error": "#cf2d56",
      "info": "#3c7cab",
      "interactive": "#206595",
      "diffAdd": "#55a583",
      "diffDelete": "#e75e78"
    },
    "overrides": {
      "text-weak": "#141414ad",
      "syntax-comment": "#141414ad",
      "syntax-keyword": "#b3003f",
      "syntax-string": "#9e94d5",
      "syntax-primitive": "#db704b",
      "syntax-variable": "#141414",
      "syntax-property": "#141414ad",
      "syntax-type": "#206595",
      "syntax-constant": "#b8448b",
      "syntax-operator": "#141414",
      "syntax-punctuation": "#141414",
      "syntax-object": "#141414",
      "markdown-heading": "#206595",
      "markdown-text": "#141414",
      "markdown-link": "#206595",
      "markdown-link-text": "#141414ad",
      "markdown-code": "#1f8a65",
      "markdown-block-quote": "#141414ad",
      "markdown-emph": "#141414",
      "markdown-strong": "#141414",
      "markdown-horizontal-rule": "#141414ad",
      "markdown-list-item": "#141414",
      "markdown-list-enumeration": "#141414ad",
      "markdown-image": "#206595",
      "markdown-image-text": "#141414ad",
      "markdown-code-block": "#141414"
    }
  },
  "dark": {
    "palette": {
      "neutral": "#181818",
      "ink": "#e4e4e4",
      "primary": "#88c0d0",
      "accent": "#88c0d0",
      "success": "#3fa266",
      "warning": "#f1b467",
      "error": "#e34671",
      "info": "#81a1c1",
      "interactive": "#82D2CE",
      "diffAdd": "#70b489",
      "diffDelete": "#fc6b83"
    },
    "overrides": {
      "text-weak": "#e4e4e45e",
      "syntax-comment": "#e4e4e45e",
      "syntax-keyword": "#82D2CE",
      "syntax-string": "#E394DC",
      "syntax-primitive": "#EFB080",
      "syntax-variable": "#e4e4e4",
      "syntax-property": "#81a1c1",
      "syntax-type": "#EFB080",
      "syntax-constant": "#F8C762",
      "syntax-operator": "#e4e4e4",
      "syntax-punctuation": "#e4e4e4",
      "syntax-object": "#e4e4e4",
      "markdown-heading": "#AAA0FA",
      "markdown-text": "#e4e4e4",
      "markdown-link": "#82D2CE",
      "markdown-link-text": "#81a1c1",
      "markdown-code": "#E394DC",
      "markdown-block-quote": "#e4e4e45e",
      "markdown-emph": "#82D2CE",
      "markdown-strong": "#F8C762",
      "markdown-horizontal-rule": "#e4e4e45e",
      "markdown-list-item": "#e4e4e4",
      "markdown-list-enumeration": "#88c0d0",
      "markdown-image": "#88c0d0",
      "markdown-image-text": "#81a1c1",
      "markdown-code-block": "#e4e4e4"
    }
  }
}
